import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { checkTextTranslation, checkTranslation, imageAddress, translate } from "../../utils/useful";
import * as actions from "../../stores/actionsList"


class MyDashbaord extends Component {
    state = {


    }
    componentDidMount() {
    }
    render() {

        return (
            <div className="w-100 no-scrollbar tower-body px-2" style={{ left: 0, width: '100%', }}>
                <button className='px-1 flexc pt-3 pb-3' onClick={() => this.props.changeStage('Home')}>
                    <img src='/assets/icons/tower/arrow-left-gray.svg' width={'22px'} className='rtl-button' style={{ cursor: 'pointer' }} />
                    <p className="font-size-15 main-c6">{translate('Dahbaord')}</p>
                </button>
                <div className='p-3 flexcc h-100'>
                    <img src='/assets/icons/tower/not-found.svg' width={300} />
                </div>
            </div>

        )
    }
}
const mapStateToProps = (state) => ({ settings: state.settings, user: state.user, resource: state.resource, notif: state.notif, relations: state.relations });
const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(actions, dispatch)
});


export default connect(mapStateToProps, mapDispatchToProps)(MyDashbaord);